import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Table: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m594.53 195.15h-473.96v389.7h538.86v-324.81c0-35.78-29.11-64.9-64.9-64.9zm0 28.86c19.87 0 36.04 16.17 36.04 36.04v54.53h-481.14v-90.57zm-324.53 120.57h360.57v90h-360.57zm-30 90h-90.57v-90h90.57zm-90.57 30h90.57v91.42h-90.57zm120.57 91.42v-91.42h360.57v91.42z' />
  </IconBase>
));

Table.displayName = 'Table';

export default Table;
